/**
 * Compact label for collapsed sidebar dock tiles — mirrors
 * MobileDock's `shortLabel ?? label` pattern (apps/sam MobileDock.tsx).
 */
export function navShortLabel(label: string, maxLen = 9): string {
  const trimmed = label.trim()
  if (!trimmed) return ''
  if (trimmed.length <= maxLen) return trimmed
  const firstWord = trimmed.split(/\s+/)[0]
  if (firstWord.length <= maxLen) return firstWord
  return `${trimmed.slice(0, maxLen - 1)}…`
}
